import { Add } from '@mui/icons-material';
import CardWrapper from '../wrapper/card';
import { fetchBusinessRequestsThunk } from '../../redux/thunks/review';
import { formatDateWithTime } from '../../helper';
import GetReviewModal from './modal/get_reviews';
import ImageClass from '../../assets';
import ImportedReviewsModal from './modal/imported';
import { settingSearchedBusiness } from '../../redux/slices/review';
import { useParams } from 'react-router';
import { AppDispatch, RootState } from '../../redux/store';
import { Avatar, Box, Button, CircularProgress, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

const RequestReviewComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams();
    const [gettingReviews, setGettingReviews] = useState<boolean>(false);
    const [reviewsImported, setReviewsImported] = useState<boolean>(false);
    const { businesses, loaders } = useSelector((state: RootState) => state.review);

    const pendingBusinesses = businesses.filter((business) => business.business_status === 'pending');

    useEffect(() => {
        const fetchAllRequests = async () => {
            try {
                await dispatch(fetchBusinessRequestsThunk(id ? parseInt(id as string, 10) : 0)).unwrap();
            } catch (e) {
                // Catch errors
            }
        };
        fetchAllRequests();
    }, []);

    const handleGetReviewsModal = () => {
        dispatch(settingSearchedBusiness([]));
        setGettingReviews(true);
    };

    if (loaders.isLoading) {
        return <Box minHeight="200px">
            <Box display="flex" alignItems="center" flexDirection="column" height="200px" justifyContent="center">
                <CircularProgress />
                <Typography variant="body2">Loading...</Typography>
            </Box>
        </Box>;
    } else if (pendingBusinesses.length === 0) {
        return (
            <Box minHeight="70vh">
                <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" gap={2}>
                    <img src={ImageClass.noEmail} alt="no overview" height="300px" />
                    <Typography variant="subtitle1" color="textSecondary" align="center">Connect your Google business account by importing reviews before sending a<br />request for a review from a customer</Typography>
                    <Button variant="contained" onClick={handleGetReviewsModal}>Import Reviews</Button>
                </Box>
                <GetReviewModal open={gettingReviews} onClose={() => setGettingReviews(false)} openImportingModal={() => setReviewsImported(true)} />
                <ImportedReviewsModal open={reviewsImported} onClose={() => setReviewsImported(false)} />
            </Box>
        );
    }
    return (
        <Box minHeight="70vh" sx={{ mt: 4 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Box></Box>
                <Typography variant="h4" gutterBottom textAlign="center" fontWeight="bold">
                    Business Requests
                </Typography>
                <Button variant="contained" onClick={handleGetReviewsModal} startIcon={<Add />}>Import Reviews</Button>
            </Box>
            <Box display="flex" flexDirection="column" gap={2} alignItems="center">
                {pendingBusinesses.map((business) => (
                    <Box width="100%" key={business.id}>
                        <CardWrapper>
                            <Box display="flex" justifyContent="space-between" alignItems="center">
                                <Box display="flex" alignItems="center" gap={2}>
                                    <Avatar src={`https://maps.googleapis.com/maps/api/place/photo?maxwidth=500&photo_reference=${business.photo_reference}&key=${process.env.REACT_APP_GOOGLE_API_KEY}`} alt={business.business_name} />
                                    <Box><Typography variant="h6" fontWeight="bold">{business.business_name}</Typography>
                                    <Typography variant="body2" color="textSecondary">{business.formatted_address}</Typography></Box>
                                </Box>
                                <Box display="flex" flexDirection="column" alignItems="end">
                                    <Typography variant="body2" color="error" fontWeight="bold" mt={1}>Status: Pending</Typography>
                                    <Typography variant="body2" color="textDisabled" mt={1}><b>Requested at:</b> {formatDateWithTime(business.created_at)}</Typography>
                                </Box>
                            </Box>
                        </CardWrapper>
                    </Box>
                ))}
            </Box>
            <GetReviewModal open={gettingReviews} onClose={() => setGettingReviews(false)} openImportingModal={() => setReviewsImported(true)} />
            <ImportedReviewsModal open={reviewsImported} onClose={() => setReviewsImported(false)} />
        </Box>
    );
};

export default RequestReviewComponent;